import React from 'react'

const ManagementCard = ({ image, name, role, bio, linkedin }) => {
  return (
    <div className="flex flex-col md:flex-row gap-5 md:gap-6 p-4 md:p-5 rounded-2xl bg-white border border-[#E6E6E6] shadow-sm">
      <div className="shrink-0">
        <img
          src={image}
          alt={name}
          className="w-full aspect-square md:w-28 object-cover rounded-xl bg-gray-100"
          draggable="false" loading="lazy" />
      </div>
      <div className="flex flex-col min-w-0">
        <h5 className="text-lg font-semibold text-[#2A2A2A] leading-tight">{name}</h5>
        <p className="text-sm text-[#007DD6] font-medium mt-0.5">{role}</p>
        <p className="text-sm text-[#5B5B5B] leading-relaxed mt-3">{bio}</p>
        {linkedin && (
          <a
            href={linkedin}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
            className="inline-flex items-center mt-4 hover:opacity-70 transition-opacity"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M9.429 8.969H13.143V10.819C13.678 9.755 15.05 8.799 17.111 8.799C21.062 8.799 22 10.917 22 14.803V22H18V15.688C18 13.475 17.465 12.227 16.103 12.227C14.214 12.227 13.429 13.572 13.429 15.687V22H9.429V8.969ZM2.57 21.83H6.57V8.799H2.57V21.83ZM7.143 4.55C7.14315 4.88528 7.07666 5.21724 6.94739 5.52659C6.81812 5.83594 6.62865 6.11651 6.39 6.352C5.9064 6.83262 5.25181 7.10165 4.57 7.1C3.88939 7.09954 3.23631 6.8312 2.752 6.353C2.51421 6.11671 2.32539 5.83582 2.19634 5.52643C2.0673 5.21704 2.00058 4.88522 2 4.55C2 3.873 2.27 3.225 2.753 2.747C3.23689 2.26816 3.89024 1.9997 4.571 2C5.253 2 5.907 2.269 6.39 2.747C6.872 3.225 7.143 3.873 7.143 4.55Z" fill="#007DD6"/>
            </svg>
          </a>
        )}
      </div>
    </div>
  )
}

export default ManagementCard
